import React, { useEffect, useState, useRef, useCallback } from "react";
import Spot from "../../common/spot/spot";
import { useSize } from "react-hook-size";
import "./sharelist.scss";
import { Card, Accordion, Button, Container, Row, Col, ListGroup, Navbar, Nav, Form, Modal } from "react-bootstrap"
import * as turf from '@turf/turf'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faEllipsisH, faPlus, faChevronLeft, faMapMarkerAlt, faUsers } from "@fortawesome/free-solid-svg-icons";
import { NavLink, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Api from "../../common/api";
import ApiV2 from "../../common/apiV2";
import Map, { Marker, GeolocateControl, ScaleControl, NavigationControl } from 'react-map-gl';
import mapboxgl from 'mapbox-gl';
import { maxBy, minBy } from "lodash";
import WebMercatorViewport, { Bounds } from "viewport-mercator-project"


const MAPBOX_TOKEN = 'pk.eyJ1IjoiY29uZ2RvZSIsImEiOiJja205NmhqY2UxZXpuMnVwbTV0dDFvZjh4In0.aadaTJC6ZbASBxqpX8Il3A';
const geolocateControlStyle = { right: 10, bottom: 135 };
const scaleControlStyle = { left: 10, bottom: 40 };
const navControlStyle = { right: 10, bottom: 40 };

const getMinOrMax = (markers, minOrMax: "max" | "min", latOrLng: "latitude" | "longitude") => {
    if (markers !== null) {
        if (minOrMax === "max") {
            return (maxBy(markers, value => value[latOrLng]))[latOrLng];
        } else {
            return (minBy(markers, value => value[latOrLng]))[latOrLng];
        }
    }
};

const getBounds = (markers) => {
    const maxLat = getMinOrMax(markers, "max", "latitude");
    const minLat = getMinOrMax(markers, "min", "latitude");
    const maxLng = getMinOrMax(markers, "max", "longitude");
    const minLng = getMinOrMax(markers, "min", "longitude");

    const southWest = [minLng, minLat];
    const northEast = [maxLng, maxLat];

    return [southWest, northEast];
};

function ViewShareList(props) {
    const [toggleDownState, setToggleDownState] = useState(true);
    const [sharelist, setSharelist] = useState({});
    const [flag, setFlag] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedRec, setSelectedRec] = useState(null);
    const [spotName, setSpotName] = useState(null);
    const [spotCaption, setSpotCaption] = useState(null);
    const [spotIsPublic, setSpotIsPublic] = useState(null);
    // const [tempRec, setTempRec] = useState(null);
    const [markerBounds, setMarkerBounds] = useState(null);
    const [recList, setRecList] = useState([]);
    const [mapStyle, setMapStyle] = useState("mapbox://styles/congdoe/ckmxmhljb0z7918mrmvrro060");
    const [currentLocation, setCurrentLocation] = useState({ latitude: null, longitude: null });
    const [location, setLocation] = useState("");
    const [markers, setMarkers] = useState(null);
    const [viewport, setViewport] = useState({});

    useEffect(() => {
        const currTime = (new Date()).getHours();
        console.log("TIME: ", currTime)
        if (!(currTime > 6 && currTime < 18)) {
            setMapStyle("mapbox://styles/congdoe/ckmxn4ko50zv917pduviuis4w");
        }
    }, []);

    useEffect(() => {
        const fetchSharelists = async () => {
            if (props.selectedSharelist.data) {
                const { data } = await ApiV2.getSharelistPlaces(props.selectedSharelist.data.id)
                setRecList(data);

                var spotMarkers = [];
                for (var i = 0; i < data.length; i++) {
                    spotMarkers.push({
                        id: i,
                        longitude: data[i].mapboxData.center[0],
                        latitude: data[i].mapboxData.center[1],
                    })
                }
                setMarkers(spotMarkers);

                var sharelist = {
                    data: props.selectedSharelist.data,
                    places: data,
                }

                props.setSelectedSharelist(sharelist);
                setSharelist(sharelist);
            }
        }
        fetchSharelists();
        setFlag(false);
    }
        , [flag]
    );

    useEffect(() => {
        const fetchSharelists = async () => {
            if (props.selectedSharelist.data) {
                const { data } = await ApiV2.getSharelistPlaces(props.selectedSharelist.data.id)
                setRecList(data);

                var spotMarkers = [];
                for (var i = 0; i < data.length; i++) {
                    spotMarkers.push({
                        id: i,
                        longitude: data[i].mapboxData.center[0],
                        latitude: data[i].mapboxData.center[1],
                    })
                }
                setMarkers(spotMarkers);

                var sharelist = {
                    data: props.selectedSharelist.data,
                    places: data,
                }

                props.setSelectedSharelist(sharelist);
                setSharelist(sharelist);
            }
        }
        fetchSharelists();
        setFlag(false);
    }
        , []
    );

    useEffect(() => {
        const updateMarkerBounds = () => {
            const newBounds = getBounds(markers);
            setMarkerBounds(newBounds);
        }
        updateMarkerBounds();
    }
        , [markers]
    );

    useEffect(() => {
        if (viewport !== {}) {
            if (markerBounds && markerBounds[0][0] !== undefined) {
                var newViewport = new WebMercatorViewport(viewport).fitBounds(markerBounds, {
                    padding: 60,
                });
                setViewport(newViewport);
            }
        }
    }, [markerBounds]);

    useEffect(() => {
        if (viewport !== {}) {
            if (markerBounds && markerBounds[0][0] !== undefined) {
                var newViewport = new WebMercatorViewport(viewport).fitBounds(markerBounds, {
                    padding: 60,
                    maxZoom: 14,
                });
                setViewport(newViewport);
            }
        }
    }, [markerBounds]);

    const mapRef = useRef();
    const mapContainerRef = useRef(null);
    const { width, height } = useSize(mapContainerRef);

    const openModal = useCallback(
        (place) => {
            setIsOpen(true);
            setSelectedRec(place);
        },
        []
    );

    const closeModal = useCallback(
        () => {
            setIsOpen(false);
            setSelectedRec(null);
        },
        []
    );

    const openEditModal = () => {
        console.log("EDIT BUTTON CLICKED!!! ");
        setSpotName(selectedRec.name);
        setSpotCaption(selectedRec.caption);
        setSpotIsPublic(selectedRec.isPublic)
        setIsEditModalOpen(true);
    }

    const closeAllModals = () => {
        setIsEditModalOpen(false);
        setSpotName(null);
        setSpotCaption(null);
        setSpotIsPublic(null);
        closeModal();
    }
    
    const closeEditModal = () => {
        setSpotName(null);
        setSpotCaption(null);
        setSpotIsPublic(null)
        setIsEditModalOpen(false);
    }

    const updateSpot = async () => {
        var updatedSpot = selectedRec;

        console.log("Before: ", selectedRec)

        updatedSpot.name = spotName;
        updatedSpot.caption = spotCaption;
        updatedSpot.isPublic = spotIsPublic;

        console.log("After: ", updatedSpot);

        try {
            const response = await ApiV2.updateSpot(
                updatedSpot
            );            
            closeAllModals();
            props.notifyInfo(
                "Successfully updated Recommendation"
            );
        } catch (error){
            console.log("unable to edit error:", JSON.stringify(error));
            props.notifyFailure(
                "Failed to edit Recommendation"
            );
        }
    }

    const deleteSharelistPlace = useCallback(
        async (place) => {
            try {
                const response = ApiV2.deleteSharelistPlace(props.selectedSharelist.data.id, place.id);

                response.then((val) => {
                    setFlag(true);
                    setIsOpen(false);
                    props.notifyInfo(
                        "Successfully deleted " + place.name
                    );
                    closeModal();
                });
            } catch (e) {
                console.log("Error: ", JSON.stringify(e));
                props.notifyFailure("Failed to delete recomendation.", JSON.stringify(e));
            }
        }

        , []);

    const getLocation = useCallback((location) => {
        setCurrentLocation(location.coords);
    }, []);

    const getDistance = (place) => {
        if(currentLocation.longitude){
            var from = turf.point([currentLocation.longitude, currentLocation.latitude]);
            var to = turf.point([place.mapboxData.center[0], place.mapboxData.center[1]]);
            var options = {units: 'miles'};
    
            var distance = turf.distance(from, to, options);
            return distance.toFixed(1);
        }
        return
    }

    const renderSpotMarkers = () => {
        const markers = recList.map(spot => {
            return (
                <Marker latitude={spot.mapboxData.center[1]} longitude={spot.mapboxData.center[0]} offsetLeft={-12} offsetTop={-30}>
                    {/* <FontAwesomeIcon onClick={() => togglePopup(!showPopup)} className='text-primary fa-2x' icon={faMapMarkerAlt} /> */}
                    <FontAwesomeIcon className='text-primary fa-2x' icon={faMapMarkerAlt} />
                </Marker>
            );
        });
        return markers;
    }

    const renderRecommendations = () => {
        const places = recList.map(place => {
            return (
                <Spot
                    place={place}
                    openModal={openModal}
                    getDistance={getDistance}
                />
            );
        });
        return places;
    }

    const renderEditModal = () => {
        return (
            <Modal show={isEditModalOpen} onHide={() => closeEditModal()} centered>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Row}>
                            <Col md={8}>
                                <Form.Control
                                    type="text"
                                    placeholder="Recommendation name"
                                    value={spotName}
                                    onChange={event => setSpotName(event.target.value)}
                                />
                            </Col>
                        </Form.Group>
                        {/* <Form.Group as={Row}>
                            <Col md={8}>
                                <Form.Control
                                    type="text"
                                    placeholder="Tags"
                                    value={}
                                    onChange={event => }
                                />
                            </Col>
                        </Form.Group> */}
                        <Form.Group as={Row} className="mb-1">
                            <Col md={8}>
                                <Form.Control
                                    as="textarea" rows="3"
                                    maxLength="280"
                                    placeholder="Caption (280 characters limit)"
                                    value={spotCaption}
                                    onChange={event => setSpotCaption(event.target.value)}
                                // onKeyPress={e => {
                                //     if (e.key === "Enter") {
                                //         this.onRegisterClicked();
                                //     }
                                // }}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group className="mb-1">
                            <Form.Check
                                type="switch"
                                label="Public"
                                defaultChecked={spotIsPublic}
                                onChange={event => {
                                    setSpotIsPublic(event.target.value);
                                    console.log("TOGGLE", JSON.stringify(event.target.value));
                                }}
                            />
                        </Form.Group>
                        <Button className="" variant="primary" size="" onClick={() => updateSpot()} block>
                            Save
                        </Button>

                        <Button onClick={() => closeEditModal()} className="blue" variant="light" size="" block>
                            Cancel
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <>
        <Navbar expand="lg" bg="light" variant="light" sticky="top" className="top-nav nav-fill">
            <Nav>
                <Nav.Link className="p-0">
                    <Button variant="link" onClick={() => props.history.goBack()}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </Button>
                </Nav.Link>
            </Nav>
            <Navbar.Brand className="brand">{sharelist.data?.name}</Navbar.Brand>
            <Nav>
                <Nav.Link>
                    <NavLink to="/editSharelist">
                        <FontAwesomeIcon icon={faPlus} />
                    </NavLink>
                </Nav.Link>
            </Nav>
        </Navbar>
        <Container className="child-container">
            <Modal show={isOpen}
                onHide={() => closeModal()}
                centered>
                <Modal.Header>
                    <Modal.Title className="modal-title">{selectedRec?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Col>
                        <Button onClick={() => closeModal()}
                            className="blue"
                            variant="light"
                            block>
                            Share
                    </Button>
                        <Button onClick={() => openEditModal()}
                            className="blue"
                            variant="light"
                            block>
                            Edit
                    </Button>
                        <Button onClick={async () => {
                            await deleteSharelistPlace(selectedRec);
                        }}
                            variant="danger"
                            block>
                            Remove
                    </Button>
                        <Button onClick={() => closeModal()}
                            className="blue"
                            variant="light"
                            block>
                            Cancel
                    </Button>
                    </Col>
                </Modal.Body>
            </Modal>

            {renderEditModal()}
            <Accordion defaultActiveKey="0">
                <Card className="p-0 full-width map-toggle">
                    <Card.Header className="p-0">
                        <Accordion.Collapse eventKey="0" className="full-width">
                            <Map
                                ref={mapRef}
                                {...viewport}
                                width="100%"
                                height="50vh"
                                mapStyle={mapStyle}
                                onViewportChange={viewport => setViewport(viewport)}
                                mapboxApiAccessToken={MAPBOX_TOKEN}
                                className='rounded'
                            >
                                {renderSpotMarkers()}
                                <GeolocateControl
                                    style={geolocateControlStyle}
                                    positionOptions={{ enableHighAccuracy: false }}
                                    trackUserLocation={true}
                                    onGeolocate={getLocation}
                                    onViewportChange={() => { console.log("Hello") }}
                                    auto
                                />
                                <NavigationControl showCompass={false} style={navControlStyle} />
                                <ScaleControl maxWidth={100} unit="imperial" style={scaleControlStyle} />
                            </Map>
                        </Accordion.Collapse>
                        <Container className="map-toggle">
                            <Row className="d-flex justify-content-center bg-white map-toggle px-3">
                                <Col className="d-flex justify-content-start">
                                {/* placeholder */}
                                </Col>
                                <Col className="d-flex justify-content-center" >
                                    <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                        <FontAwesomeIcon id="toggle-down" icon={faChevronDown} />
                                    </Accordion.Toggle>
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                <NavLink to="/profile/viewSharelist/shares">
                                    <FontAwesomeIcon icon={faUsers} />
                                </NavLink>
                                </Col>
                            </Row>
                        </Container>
                    </Card.Header>
                </Card>
            </Accordion>
            <ListGroup className="full-width bottom-pad">
                {renderRecommendations()}
            </ListGroup>
        </Container>
        </>
    );
}

export default withRouter(ViewShareList);

ViewShareList.propTypes = {
    setSelectedSharelist: PropTypes.func.isRequired,
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired,
};


